import { memo, useRef, useState } from 'react';
import styles from './index.module.less';
import { useMobx } from '@/hooks/useMobx';
import { PrimeCommodityMap } from '@/utils/configs/prime.config';
import cls from 'classnames';
import useReSizePrimeDelivery from '@/pages/product/hooks/useReSizePrimeDelivery';

interface IPrimeWrapProps {
  cid: number;
}

const PrimeWrap = (props: IPrimeWrapProps) => {
  const { cid } = props;
  const [isVisible, setIsVisible] = useState(true);
  const [loading, setLoading] = useState(true);
  const primeWrapRef = useRef<HTMLDivElement>(null);
  const {
    area: {
      country: { code: countryCode },
    },
    product: {
      productDetail: { id: pid },
    },
  } = useMobx(['area', 'product']);

  const onVisibleChange = (visible: boolean) => {
    setIsVisible(visible);
    setLoading(false);
  };

  useReSizePrimeDelivery(primeWrapRef, onVisibleChange);

  // x3、x4、x5、ace pro、ace pro2产品页才展示
  if (
    !cid ||
    !isVisible ||
    ![25, 26, 19, 30, 33].includes(pid) ||
    countryCode !== 'US' ||
    !Object.values(PrimeCommodityMap).includes(cid?.toString())
  )
    return null;
  return (
    <div
      className={cls({
        [styles.primeWrap]: true,
        [styles.visible]: !loading,
      })}
    >
      <div ref={primeWrapRef}>
        <amazon-delivery-message
          product-sku={cid?.toString()}
          message-type='delivery-estimate'
          color-mode='light'
        ></amazon-delivery-message>
      </div>
    </div>
  );
};

export default memo(PrimeWrap);
